import React, { useState, useEffect } from "react";
import ReactSearchBox from "react-search-box";
import { FaSearch } from 'react-icons/fa'

const CustomSearch = ({ callbackFn }) => {
    const [value, setValue] = useState('');

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            callbackFn(value);
        }, 500);

        return () => clearTimeout(timeoutId);
    }, [value, callbackFn]);

    const handleKeyPress = (e, val, isIconClick) => {
        if (e.which === 13 || isIconClick) {
            callbackFn(val);
            e.preventDefault();
        }
    }
    return (
        <form className="form customSearch" onSubmit={(e) => e.preventDefault()}>
            <div className="inputIcon">
                <FaSearch onClick={e => handleKeyPress(e, value, true)} />
                <input type='text' className="searchBar" placeholder="Search..." value={value} onChange={e => setValue(e.target.value)} onKeyPress={e => handleKeyPress(e, e.target.value)} />
            </div>
        </form>
    );
};

export default CustomSearch;